import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement, ReactNode } from 'react'

import Tooltip from '~/components/Tooltip'

import './styles.scss'

interface Props {
  message?: ReactNode
}

const AnalyticWarningTooltip = ({ message }: Props): ReactElement => {
  return (
    <Tooltip
      align={{ points: ['bl', 'tl'] }}
      className="warning-tooltip-content"
      mouseEnterDelay={0.2}
      overlay={
        <div className="analytics-warning-tooltip-value-container">
          <div className="upper-case-text">Not calculated over the period</div>
          <div className="message">{message}</div>
        </div>
      }
      placement="topRight"
      trigger="hover"
    >
      <div className="analytics-warning-tooltip-icon">
        <MdInfoOutline color="#fdbf4e" size={20} />
      </div>
    </Tooltip>
  )
}

export default AnalyticWarningTooltip
